/** Date / time formatting helpers (locale-aware, timezone-agnostic display). */

export function formatTime(iso: string): string {
  return new Date(iso).toLocaleTimeString([], {
    hour: 'numeric',
    minute: '2-digit',
  })
}

export function formatTimeRange(startIso: string, endIso: string): string {
  return `${formatTime(startIso)} – ${formatTime(endIso)}`
}

export function formatDayLabel(iso: string): string {
  return new Date(iso).toLocaleDateString([], {
    weekday: 'long',
    month: 'long',
    day: 'numeric',
  })
}

export function formatShortDay(iso: string): string {
  return new Date(iso).toLocaleDateString([], {
    weekday: 'short',
    month: 'short',
    day: 'numeric',
  })
}

export function formatDateRange(startIso: string, endIso: string): string {
  const start = new Date(startIso)
  const end = new Date(endIso)
  const sameMonth = start.getMonth() === end.getMonth()
  const startStr = start.toLocaleDateString([], {
    month: 'long',
    day: 'numeric',
  })
  const endStr = end.toLocaleDateString([], {
    month: sameMonth ? undefined : 'long',
    day: 'numeric',
    year: 'numeric',
  })
  return `${startStr} – ${endStr}`
}

/** Group an array by a derived key, preserving insertion order of keys. */
export function groupBy<T>(items: T[], keyFn: (item: T) => string) {
  const map = new Map<string, T[]>()
  for (const item of items) {
    const key = keyFn(item)
    const arr = map.get(key)
    if (arr) arr.push(item)
    else map.set(key, [item])
  }
  return map
}
